















































import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Resource } from '@/modules/backend/Entities/Resource';
import ProvidersModule from '@/store/dashboard/providers/ProvidersModule';
import { resolveModule } from '@/store';
import { Provider } from '@/modules/backend/Entities/Provider';
import { EditProviderData } from '@/modules/backend/Dto/EditProviderData';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import Mixin from '@/mixins/base';
import { ValidationObserver } from '@/plugins/vee-validate';

const ResourcesModule = namespace('dashboard/resources');
@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class ProviderEditDialog extends Mixins(Mixin) {
  private get resources(): Array<Resource> {
    return this.resourcesList;
  }

  @Ref('observer')
  private readonly observer!: ValidationObserver;

  @Prop({ required: true, type: Provider }) private readonly provider!: Provider;

  private readonly providers: ProvidersModule = resolveModule(ProvidersModule);

  @ResourcesModule.Action('Fetch')
  private readonly fetchResources!: () => Promise<void>;

  @ResourcesModule.Getter('Resources')
  private readonly resourcesList!: Resource[];

  private form: EditProviderData = new EditProviderData({
    providerId: this.provider.getId(),
    name: this.provider.getName(),
    resourceIds: this.provider.getResources().map((resource) => resource.getId())
  });

  public async mounted(): Promise<void> {
    await this.fetchResources();
  }

  private async create(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      await this.providers.edit(this.form);
    } else {
      throw new Error('Validation error');
    }
  }

  private clearForm(): void {
    this.observer.reset();
    this.form.name = this.provider.getName();
    this.form.resourceIds = this.provider.getResources().map((resource) => resource.getId());
  }

  private dialogOpenHandler(): void {
    this.clearForm();
  }
}
